import axios from "axios";

/**
 * @typedef {object} Params
 * @property {object | undefined} body
 * @property {number | undefined} id
 */

export const locationHelper = {
    /**
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    fetch: function() {
        return axios.get(
          `/api/location/get-countries-with-states`,
          { withCredentials: true }
        );
    },
};

export const isoCategories = {
    /**
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/iso-categories', {withCredentials: true});
    },
    
    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/iso-categories', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/iso-categories/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/iso-categories/${id}`, {withCredentials: true});
    },
};

export const isoSubCategories = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/iso-sub-categories', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/iso-sub-categories', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/iso-sub-categories/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/iso-sub-categories/${id}`, {withCredentials: true});
    },
};

export const hotelStayFactors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/hotel-stay-factors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/hotel-stay-factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/hotel-stay-factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/hotel-stay-factors/${id}`, {withCredentials: true});
    },
};

export const electricFactors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/electric-factors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/electric-factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/electric-factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/electric-factors/${id}`, {withCredentials: true});
    },
};

export const gwpGroups = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/gwp-groups', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/gwp-groups', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/gwp-groups/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/gwp-groups/${id}`, {withCredentials: true});
    },
};

export const gwpFactors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/gwp-factors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/gwp-factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/gwp-factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/gwp-factors/${id}`, {withCredentials: true});
    },
};

export const isoSectors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/sectors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/sectors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/sectors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/sectors/${id}`, {withCredentials: true});
    },
};

export const combustionTypes = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/combustion-types', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/combustion-types', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/combustion-types/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/combustion-types/${id}`, {withCredentials: true});
    },
};

export const mobilityTypes = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/mobility-types', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/mobility-types', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/mobility-types/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/mobility-types/${id}`, {withCredentials: true});
    },
};

export const combustionCategories = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/combustion-categories', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/combustion-categories', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/combustion-categories/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/combustion-categories/${id}`, {withCredentials: true});
    },
};

export const combustionFactors = {
    fetch: function(sectorId) {
        return axios.get(`/api/carbon-admin/iso/combustion-factors/${sectorId}`, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/combustion-factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/combustion-factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/combustion-factors/${id}`, {withCredentials: true});
    },
};

export const refrigerantFactors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/iso/refrigerant-factors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/iso/refrigerant-factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/iso/refrigerant-factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/iso/refrigerant-factors/${id}`, {withCredentials: true});
    },
};

export const epaSectors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/epa/epa-sectors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/epa/epa-sectors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/epa/epa-sectors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/epa/epa-sectors/${id}`, {withCredentials: true});
    },
};

export const epaFactors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/epa/epa-factors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/epa/epa-factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/epa/epa-factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/epa/epa-factors/${id}`, {withCredentials: true});
    },
};

export const defraScopes = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/scopes', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/scopes', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/scopes/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/scopes/${id}`, {withCredentials: true});
    },
};

export const defraCategories = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/categories', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/categories', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/categories/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/categories/${id}`, {withCredentials: true});
    },
};

export const defraActivities = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/activities', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/activities', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/activities/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/activities/${id}`, {withCredentials: true});
    },
};

export const defraTypes = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/types', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/types', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/types/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/types/${id}`, {withCredentials: true});
    },
};

export const defraFuels = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/fuels', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/fuels', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/fuels/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/fuels/${id}`, {withCredentials: true});
    },
};

export const defraUnits = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/units', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/units', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/units/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/units/${id}`, {withCredentials: true});
    },
};

export const defraFactors = {
    fetch: function() {
        return axios.get('/api/carbon-admin/defra/factors', {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    create: function(params) {
        return axios.post('/api/carbon-admin/defra/factors', params.body, {withCredentials: true});
    },

    /**
     * @param {Params} params 
     * @returns {Promise<import("axios").AxiosResponse>}
     */
    update: function(params) {
        return axios.post(`/api/carbon-admin/defra/factors/${params.id}`, params.body, {withCredentials: true});
    },

    /**
     * @param {number} id 
     * @returns {Promise<AxiosResponse>}
     */
    delete: function(id) {
        return axios.delete(`/api/carbon-admin/defra/factors/${id}`, {withCredentials: true});
    },
};